<template>
  <div :class="classes">
    <svg
      v-if="content.hand"
      :class="`c-hotspot__hand c-hotspot__hand--${content.hand}`"
    >
      <path
        d="M9.5 18.26a.98.98 0 01-.98-.98V2.93a2.94 2.94 0 015.87 0v13.05a.98.98 0 01-1.96 0V2.93a.98.98 0 00-1.95 0v14.35c0 .54-.44.98-.98.98z"
      />
      <path
        d="M17.32 16.96a.98.98 0 01-.97-.98v-5.22a.98.98 0 00-1.96 0 .98.98 0 01-1.96 0 2.94 2.94 0 015.87 0v5.22c0 .54-.44.98-.98.98z"
      />
      <path
        d="M21.24 16.96a.98.98 0 01-.98-.98v-3.91a.98.98 0 00-1.96 0 .98.98 0 01-1.95 0 2.94 2.94 0 015.87 0v3.9c0 .55-.44.99-.98.99z"
      />
      <path
        d="M19.93 30h-7.22c-1.57 0-3.37-.9-4.92-2.49a14.28 14.28 0 01-3.83-10.27 4.62 4.62 0 014.57-4.52h.97a.98.98 0 010 1.95h-.97a2.61 2.61 0 00-2.62 2.6 12.2 12.2 0 003.28 8.87c1.17 1.2 2.48 1.9 3.52 1.9h7.22c2.34 0 4.24-1.9 4.24-4.24V13.37a.98.98 0 00-1.95 0 .98.98 0 01-1.96 0 2.94 2.94 0 015.87 0V23.8a6.2 6.2 0 01-6.2 6.2z"
      />
    </svg>
  </div>
</template>

<script>
import contentComponent from "@/mixins/content";

export default {
  name: "c-hotspot",
  mixins: [contentComponent],
};
</script>

<style lang="scss" scoped>
.c-hotspot {
  &--hotspot {
    cursor: pointer;
  }

  &--bordered {
    border-radius: 0.25rem;
    border: 0.25rem solid #ffc800;
  }

  &__hand {
    width: 30px;
    height: 30px;
    fill: #fff;
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 0);
    animation: hand 2s ease infinite;

    &--dark {
      fill: #292983;
    }
  }
  @keyframes hand {
    0% {
      transform: translate(-50%, 0);
    }
    50% {
      transform: translate(-50%, 5px);
    }
    100% {
      transform: translate(-50%, 0);
    }
  }
}
</style>
